/**
 * Freeze V2 — Rules Dialog
 *
 * Informational dialog listing the embryo-creation rules (parity with v1).
 */
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

type RulesDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const RULES = [
  "Embryos will not be created if they don't contain an owner",
  'Embryos that require TT will not be created until they have TT/CZ checked',
  'Prediction Tech will not be overridden if it is already filled in',
  'Slaughterhouse Embryos will always auto-generate with Stage 0',
  "Slaughterhouse Grade 2 Embryos will contain an 'X' at the end of the Cane",
  'All "Fill Down" checkboxes will only fill down when rows are checked and stage/grade are filled',
];

export function RulesDialog({ open, onOpenChange }: RulesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Rules</DialogTitle>
        </DialogHeader>
        <ul className="list-disc space-y-2 pl-5 text-sm text-gray-700 dark:text-gray-300">
          {RULES.map((rule) => (
            <li key={rule}>{rule}</li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
